import React from 'react'
import withStyles from 'react-jss'
import { useIsAuthenticated } from "@azure/msal-react"

import App from './App'
import styles from './App.styles'

const withMsalAuthentication = (Component: any) => {
  return (props: any) => {
    const isAuthenticated = useIsAuthenticated()

    return <Component isAuthenticated={isAuthenticated} {...props} />
  }
}

export default withStyles(styles)(withMsalAuthentication(App))
